<template>
  <div class="tnt-root">
    <v-app-bar app class="tnt-bar" :class="vm.menu_dialog ? 'app_z_index' : ''" color="#fff">
      <section v-if="!vm.hide_navigation" class="tnt-hamburger" :class="vm.board_bg_cls" @click="vm.open__dialog()">
        <img src="@/assets/Menu/hamburger_icon.svg" width="20" height="18" />
      </section>

      <div class="tnt-logo">
        <img v-if="vm.is_family_book" src="@/assets/familybook_logo.svg" class="tnt-logo-img" />
        <img v-else-if="vm.logoUrl" :src="vm.logoUrl" @error="vm.handleLogoError" class="tnt-logo-img" />
        <img v-else :src="vm.menuLogo_Src" class="tnt-logo-img" />
      </div>

      <!-- ═══ Center: board/family icon cluster OR favourites + Setup Guide ═══ -->
      <template v-if="!vm.isfamily_book && vm.is_boardpage">
        <v-spacer></v-spacer>
        <v-tooltip bottom><template v-slot:activator="{on,attrs}"><v-icon v-bind="attrs" v-on="on" class="mr-3" @click="vm.redirect_to_dashboard()">mdi-view-dashboard</v-icon></template><span>Dashboard</span></v-tooltip>
        <v-tooltip bottom><template v-slot:activator="{on,attrs}"><v-icon v-bind="attrs" v-on="on" @click="vm.redirect_to_leader_ship_stucture()">mdi-family-tree</v-icon></template><span>Leadership Structure</span></v-tooltip>
        <v-spacer></v-spacer>
      </template>
      <template v-else-if="vm.isfamily_book">
        <v-spacer></v-spacer>
        <v-tooltip bottom><template v-slot:activator="{on,attrs}"><v-icon v-bind="attrs" v-on="on" class="mr-3" @click="vm.redirect_to_family_tree()">mdi-family-tree</v-icon></template><span>Family Tree</span></v-tooltip>
        <v-tooltip bottom><template v-slot:activator="{on,attrs}"><v-icon v-bind="attrs" v-on="on" class="mr-3" @click="vm.redirect_to_family_office()">mdi-account-group</v-icon></template><span>Family Office</span></v-tooltip>
        <v-tooltip bottom><template v-slot:activator="{on,attrs}"><v-icon v-bind="attrs" v-on="on" class="mr-3" @click="vm.redirect_to_family_forum()">mdi-forum</v-icon></template><span>Family Forum</span></v-tooltip>
        <v-tooltip bottom><template v-slot:activator="{on,attrs}"><img v-bind="attrs" v-on="on" src="@/assets/messages-2.svg" width="19" height="19" style="cursor:pointer" @click="vm.open_chat()" /></template><span>Chat Room</span></v-tooltip>
        <v-spacer></v-spacer>
      </template>
      <template v-else-if="!vm.is_board_page && !vm.is_family_book && !vm.hide_navigation">
        <v-spacer></v-spacer>
        <v-menu v-if="vm.setupPct < 100" open-on-hover close-on-content-click offset-y bottom nudge-bottom="4" content-class="setup-popover-menu" z-index="10000">
          <template v-slot:activator="{ on, attrs }">
            <v-btn x-small dark class="mr-2 text-capitalize nav-action-btn" style="background:linear-gradient(90deg,#6366F1 0%,#4F46E5 50%,#4338CA 100%)" v-bind="attrs" v-on="on" @click="vm.closeMenuAndGo('/setup_guide')">
              <svg class="mr-1" viewBox="0 0 36 36" width="14" height="14">
                <circle cx="18" cy="18" r="15.9" fill="none" stroke="rgba(255,255,255,.25)" stroke-width="3.5"/>
                <circle cx="18" cy="18" r="15.9" fill="none" stroke="#fff" stroke-width="3.5" stroke-linecap="round" :stroke-dasharray="vm.setupPct + ' 100'" style="transform:rotate(-90deg);transform-origin:center"/>
              </svg>
              {{ vm.setupPct }}% Setup
            </v-btn>
          </template>
          <v-card class="setup-popover-card">
            <div class="setup-pop-header"><div><div class="setup-pop-title">{{ vm.setupPct >= 100 ? 'Setup complete' : 'Setup in progress' }}</div><div class="setup-pop-sub">{{ vm.setupDoneTasks }}/{{ vm.setupTotalTasks }} tasks done</div></div></div>
            <div class="setup-pop-track"><div class="setup-pop-fill" :style="{ width: vm.setupPct + '%' }"></div></div>
            <button class="setup-pop-btn" @click="vm.closeMenuAndGo('/setup_guide')">{{ vm.setupPct >= 100 ? 'View Setup' : 'Continue Setup' }} &rarr;</button>
          </v-card>
        </v-menu>

        <v-tooltip v-for="fav in cappedFavourites" :key="'t-qf-' + fav.module_key" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div class="qa-fav-avatar" :style="{ background: vm.getFavItemColor(fav.module_key, fav.module_category) }" v-bind="attrs" v-on="on" @click="vm.closeMenuAndGo(fav.module_route)">
              <v-icon v-if="vm.hasMeaningfulIcon(fav.module_icon)" size="14" color="#fff">{{ fav.module_icon }}</v-icon>
              <span v-else class="qa-fav-avatar-text">{{ vm.getFavInitials(fav.module_name) }}</span>
            </div>
          </template>
          <span>{{ fav.module_name }}</span>
        </v-tooltip>

        <div v-if="cappedFavourites.length" class="qa-bar-divider"></div>
        <QuickAccessPanel />
        <v-spacer></v-spacer>
      </template>
      <template v-else>
        <v-spacer></v-spacer>
      </template>

      <!-- ═══ Right: core action icons + More + profile ═══ -->
      <v-tooltip v-if="!vm.is_family_book && !vm.hide_navigation" bottom z-index="10000">
        <template v-slot:activator="{ on, attrs }">
          <div class="nav-chat-btn mr-2" v-bind="attrs" v-on="on" @click="vm.closeMenuAndGo('/chat_hub')">
            <svg viewBox="0 0 24 24" fill="none" width="17" height="17">
              <path d="M12 3C6.48 3 2 6.58 2 11c0 2.18 1.08 4.15 2.85 5.58L4 21l4.36-1.78c1.13.37 2.36.78 3.64.78 5.52 0 10-3.58 10-8s-4.48-8-10-8z" fill="#fff"/>
              <circle cx="8.5" cy="11" r="1.2" fill="#E91E63"/><circle cx="12" cy="11" r="1.2" fill="#9C27B0"/><circle cx="15.5" cy="11" r="1.2" fill="#3F51B5"/>
            </svg>
            <span v-if="vm.chatUnread > 0" class="nav-chat-badge">{{ vm.chatUnread > 99 ? '99+' : vm.chatUnread }}</span>
            <span v-else class="nav-chat-dot"></span>
          </div>
        </template>
        <span>Chat</span>
      </v-tooltip>

      <v-tooltip v-if="!vm.is_board_page && !vm.is_family_book && !vm.hide_navigation" bottom z-index="10000">
        <template v-slot:activator="{ on, attrs }">
          <div class="nav-minutes-btn mr-2" v-bind="attrs" v-on="on" @click="vm.toggleQuickMinutes()">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
          </div>
        </template>
        <span>Quick Add Minutes</span>
      </v-tooltip>

      <v-tooltip v-if="!vm.is_family_book && !vm.hide_navigation" bottom z-index="10000">
        <template v-slot:activator="{ on, attrs }">
          <div class="nav-impl-btn mr-2" v-bind="attrs" v-on="on" @click="vm.$router.push('/starr_implementation_programme')">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>
          </div>
        </template>
        <span>STARR Implementation Programme</span>
      </v-tooltip>

      <v-menu v-if="hasMoreItems" offset-y left>
        <template v-slot:activator="{ on, attrs }">
          <div class="tnt-more-btn mr-2" v-bind="attrs" v-on="on"><v-icon color="#5A5A72" size="19">mdi-dots-horizontal</v-icon></div>
        </template>
        <v-list dense class="sub_list_txt" style="min-width:220px">
          <v-list-item v-if="entityLabel">
            <v-list-item-title class="sub_list_txt">
              <a v-if="vm.is__adani_page" href="https://www.adanienterprises.com/" target="_blank" rel="noopener noreferrer">{{ entityLabel }}</a>
              <a v-else-if="vm.is__gmr_page" href="https://www.gmrgroup.in/airports/" target="_blank" rel="noopener noreferrer">{{ entityLabel }}</a>
              <a v-else-if="vm.is__vardhman_page" href="https://www.vardhman.com/" target="_blank" rel="noopener noreferrer">{{ entityLabel }}</a>
              <a v-else-if="vm.is__parle_page" href="https://www.parleproducts.com/" target="_blank" rel="noopener noreferrer">{{ entityLabel }}</a>
              <a v-else-if="vm.is__granules_page" href="https://granulesindia.com/" target="_blank" rel="noopener noreferrer">{{ entityLabel }}</a>
              <a v-else-if="vm.is__emami_page" href="https://www.emamiltd.in/" target="_blank" rel="noopener noreferrer">{{ entityLabel }}</a>
              <span v-else>{{ entityLabel }}</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="vm.isTrialSubscription && !vm.is_board_page && !vm.is_family_book">
            <v-list-item-title class="sub_list_txt"><v-chip x-small dark color="amber darken-3" class="font-weight-bold">TRIAL</v-chip> Trial subscription</v-list-item-title>
          </v-list-item>
          <v-list-item v-for="fav in overflowFavourites" :key="'t-more-qf-' + fav.module_key" @click="vm.closeMenuAndGo(fav.module_route)">
            <v-list-item-title class="sub_list_txt"><v-icon v-if="vm.hasMeaningfulIcon(fav.module_icon)" size="18">{{ fav.module_icon }}</v-icon><v-icon v-else size="18">mdi-star-outline</v-icon> {{ fav.module_name }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="vm.entity__Data.length > 1" @click="vm.Switch_Entities()">
            <v-list-item-title class="sub_list_txt"><v-icon size="18">mdi-swap-horizontal</v-icon> Switch Entity</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="vm.has_multi_domain" @click="vm.open_switch_company()">
            <v-list-item-title class="sub_list_txt"><v-icon size="18">mdi-office-building-outline</v-icon> Switch Company</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="vm.isSingleEntity && vm.hasMultipleHosts" @click="hostMenuOpen = true">
            <v-list-item-title class="sub_list_txt"><v-icon size="18">mdi-star-settings-outline</v-icon> Switch Host</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <section v-bind="attrs" v-on="on" class="justify-center align-center d-flex" style="cursor:pointer">
            <img :src="vm.profileImage" @error="vm.setFallbackImage" class="prof_img" alt="profile" />
          </section>
        </template>
        <v-list class="sub_list_txt">
          <v-list-item @click="vm.UpdateProfile()"><v-list-item-title class="sub_list_txt"><v-icon size="20">mdi-account-details</v-icon> My Profile</v-list-item-title></v-list-item>
          <v-list-item v-if="vm.entity__Data.length > 1" @click="vm.Switch_Entities()"><v-list-item-title class="sub_list_txt"><v-icon size="20">mdi-swap-horizontal</v-icon> Entity : {{ vm.entity_name }}</v-list-item-title></v-list-item>
          <v-list-item v-if="vm.setupPct >= 100" @click="vm.closeMenuAndGo('/setup_guide')"><v-list-item-title class="sub_list_txt"><v-icon size="20">mdi-cog-outline</v-icon> Setup Guide</v-list-item-title></v-list-item>
          <v-list-item @click="vm.closeMenuAndGo('/help')"><v-list-item-title class="sub_list_txt"><v-icon size="20">mdi-help-circle-outline</v-icon> Help</v-list-item-title></v-list-item>
          <v-list-item @click="vm.logout()"><v-list-item-title class="sub_list_txt"><v-icon size="20">mdi-logout</v-icon> Logout</v-list-item-title></v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- ═══ Switch Host dialog (company + host lists, same data/methods as desktop) ═══ -->
    <v-dialog v-model="hostMenuOpen" max-width="380">
      <v-card class="rounded-lg">
        <v-card-title class="py-3">Switch Host</v-card-title>
        <v-divider></v-divider>
        <v-list dense>
          <template v-if="vm.has_company_data && vm.company_dataset && vm.company_dataset.length > 0">
            <v-subheader>Select Company</v-subheader>
            <v-list-item v-for="company in vm.company_dataset" :key="'t-company-' + company.id" @click="vm.selectCompany(company)"
              :class="{ 'company-selected': vm.company_id === company.id }">
              <v-list-item-icon><v-icon :color="vm.company_id === company.id ? '#4CAF50' : '#7E8299'">{{ vm.company_id === company.id ? 'mdi-office-building' : 'mdi-office-building-outline' }}</v-icon></v-list-item-icon>
              <v-list-item-title>{{ company.name }}</v-list-item-title>
              <v-list-item-icon v-if="vm.company_id === company.id"><v-icon color="#4CAF50">mdi-check-circle</v-icon></v-list-item-icon>
            </v-list-item>
            <v-divider class="my-2"></v-divider>
          </template>
          <v-subheader>Select Host</v-subheader>
          <v-list-item v-for="h in visibleHosts" :key="'t-host-' + h.key" @click="switchHost(h.key)" :class="{ 'host-selected': vm.isCurrentHost(h.key) }">
            <v-list-item-icon><v-icon :color="vm.isCurrentHost(h.key) ? h.solid : '#7E8299'">{{ vm.isCurrentHost(h.key) ? 'mdi-star' : 'mdi-star-outline' }}</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title :style="vm.isCurrentHost(h.key) ? { color: h.solid, fontWeight: 700 } : {}">{{ h.label }}</v-list-item-title>
              <v-list-item-subtitle>{{ h.subtitle }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action class="my-0">
              <v-icon :color="vm.user_favourite && vm.user_favourite.toUpperCase() === h.favKey ? h.solid : '#B5B5C3'" size="18"
                @click.stop="vm.setFavouriteHost(h.favKey)">{{ vm.user_favourite && vm.user_favourite.toUpperCase() === h.favKey ? 'mdi-heart' : 'mdi-heart-outline' }}</v-icon>
            </v-list-item-action>
            <v-list-item-icon v-if="vm.isCurrentHost(h.key)"><v-icon :color="h.solid">mdi-check-circle</v-icon></v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import QuickAccessPanel from "@/components/Menu/QuickAccessPanel.vue";

const FAV_CAP = 3

export default {
  name: 'TopNavBarTablet',
  components: { QuickAccessPanel },
  props: { vm: { type: Object, required: true } },
  data() {
    return {
      hostMenuOpen: false,
      hosts: [
        { key: 'starr', flag: 'entity_starr_flag', label: 'Starr', subtitle: 'Compliance', solid: '#9C27B0', favKey: 'STARR' },
        { key: 'board', flag: 'entity_board_flag', label: 'Board', subtitle: 'Board Page', solid: '#FF5722', favKey: 'BOARD' },
        { key: 'familybook', flag: 'entity_family_book_flag', label: 'Familybook', subtitle: 'Family Tree', solid: '#5782C7', favKey: 'FAMILYBOOK' },
      ],
    }
  },
  computed: {
    cappedFavourites() { return (this.vm.topBarFavourites || []).slice(0, FAV_CAP) },
    overflowFavourites() { return (this.vm.topBarFavourites || []).slice(FAV_CAP) },
    visibleHosts() { return this.hosts.filter(h => this.vm[h.flag]) },
    entityLabel() {
      if (this.vm.is__adani_page) return 'Adani Enterprises Ltd'
      if (this.vm.is__gmr_page) return 'GMR Airports Limited'
      if (this.vm.is__vardhman_page) return 'Vardhman'
      if (this.vm.is__parle_page) return 'Parle Products'
      if (this.vm.is__granules_page) return 'Granules India'
      if (this.vm.is__emami_page) return 'Emami Ltd'
      return this.vm.entity_name
    },
    hasMoreItems() {
      return !!this.entityLabel
        || (this.vm.isTrialSubscription && !this.vm.is_board_page && !this.vm.is_family_book)
        || this.overflowFavourites.length > 0
        || this.vm.entity__Data.length > 1
        || this.vm.has_multi_domain
        || (this.vm.isSingleEntity && this.vm.hasMultipleHosts)
    },
  },
  methods: {
    switchHost(key) {
      this.hostMenuOpen = false
      this.vm.switchToHost(key)
    },
  },
}
</script>

<style scoped>
.tnt-root >>> .tnt-bar.v-app-bar { box-shadow: 0px 4.5px 11.24px 0px #091E421A !important; height: 60px !important; }
.tnt-root >>> .tnt-bar .v-toolbar__content { height: 60px !important; padding: 0 14px !important; overflow: visible !important; }

.tnt-hamburger { width: 44px; height: 44px; border-radius: 10px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; cursor: pointer; background: linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%); transition: transform .15s; }
.tnt-hamburger:hover { transform: scale(1.05); }
.tnt-logo { display: flex; align-items: center; margin-left: 12px; min-width: 0; flex-shrink: 0; }
.tnt-logo-img { height: 30px; width: auto; max-width: 110px; object-fit: contain; }

.qa-fav-avatar { width: 28px; height: 28px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; margin: 0 3px; flex-shrink: 0; transition: transform .15s ease; }
.qa-fav-avatar:hover { transform: scale(1.12); }
.qa-fav-avatar-text { font-size: 9.5px; font-weight: 700; color: #fff; }
.qa-bar-divider { width: 1px; height: 20px; background: #D1D5DB; margin: 0 10px; flex-shrink: 0; }

.nav-minutes-btn, .nav-impl-btn, .nav-chat-btn { position: relative; width: 32px; height: 32px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: transform .15s ease; }
.nav-minutes-btn { background: linear-gradient(135deg, #E8553A, #1e2b6e); }
.nav-impl-btn { background: linear-gradient(135deg, #D64B7A, #3B4CC0); }
.nav-chat-btn { background: linear-gradient(135deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%); }
.nav-minutes-btn:hover, .nav-impl-btn:hover, .nav-chat-btn:hover { transform: scale(1.1); }
.nav-chat-dot { position: absolute; top: 1px; right: 1px; width: 8px; height: 8px; background: #22c55e; border: 2px solid #fff; border-radius: 50%; }
.nav-chat-badge { position: absolute; top: -4px; right: -4px; min-width: 15px; height: 15px; padding: 0 3px; background: #ef4444; color: #fff; font-size: 9px; font-weight: 700; line-height: 15px; text-align: center; border-radius: 8px; border: 2px solid #fff; box-sizing: content-box; }

.tnt-more-btn { width: 32px; height: 32px; border-radius: 50%; background: #F5F8FA; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: background .15s; }
.tnt-more-btn:hover { background: #E4E6EF; }

.prof_img { width: 36px; height: 36px; border-radius: 8px; object-fit: cover; }

.nav-action-btn { border-radius: 6px !important; font-weight: 500 !important; letter-spacing: .3px !important; height: 26px !important; padding: 0 10px !important; font-size: 11px !important; background-color: transparent !important; white-space: nowrap !important; }
.app_z_index { z-index: 500 !important; }

.sub_list_txt { font-weight: 400; font-size: 12px; color: #3F4254; }
.host-selected .v-list-item__title { font-weight: 600; }
.company-selected { background: rgba(76, 175, 80, 0.08) !important; }
.company-selected .v-list-item__title { font-weight: 600; color: #4CAF50; }

/* Reuse the Quick Access panel as-is, presented as a wider adjusted sheet on tablet */
>>> .qa-dropdown { max-width: 92vw !important; }
</style>
